import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { ConfigurationContext } from '../context/ConfigurationContext'
import { UserContext } from '../context/UserContext'
import { ViewsContext } from '../context/ViewsContext'
import SummaryContainer from '../components/containers/SummaryContainer'
import { v4 as uuidv4 } from 'uuid';

const SummaryView = () => {
  const { configurations } = useContext(ConfigurationContext);
  const { views } = useContext(ViewsContext);
  const [image, setImage] = useState({loaded: false});
  const {
    getAnswers,
    configurationId,
  } = useContext(UserContext);
  const [ next, setNext ] = useState(null);
  const summation_view = views.items.find( item => item.view === 'summation_view' );
  const imageLoaded    = image.loaded;
  const image_url      = summation_view.image_url;
  const drop_shadow    = summation_view.drop_shadow;
  const text           = summation_view.text;
  const currentProduct = configurations.items.find( item => item.id === parseInt(configurationId));
  const questions      = currentProduct.fields;

  function handleSubmit() {
    setNext(null);
  }

  let answers = [];
  let answersIndex = 0;
  let questionsSliders = [];
  let answersSliders = [];
  let answersSliderIndex = 0;

  const banner = document.querySelector('#banner');
  let bannerClasses = 'absolute w-full h-full';
  let bannerStyle = {};
  
  if(imageLoaded) {
    if(drop_shadow && banner) {
      bannerClasses = 'shadow-lg shadow-['+drop_shadow+'] blur absolute w-full h-full';
      
      banner.style['--tw-shadow-color'] = drop_shadow;
      banner.style['--tw-shadow: var(--tw-shadow-colored)'] = 'var(--tw-shadow-colored)';
      banner.style['--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)'] = drop_shadow;
    }
    bannerStyle = {
      shadow: {
        ['--tw-shadow-color']: drop_shadow,
        ['--tw-shadow']: 'var(--tw-shadow-colored)',
        ['--tw-shadow-colored']: '0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)'
      }
    }
  }

  let averageValues = 0;
  // Answers
  for ( let i = 0; i < getAnswers().length; i++ ) {
    let answer = getAnswers()[i]['answer'];
    if( typeof answer === 'number' ) {
      answers[answersIndex] = answer;
      answersIndex++;
    } else if(typeof answer === 'string') {
      answers[answersIndex] = answer.split(',')[0] + ' - ' + answer.split(',')[1];
      console.log(answers[answersIndex]);
      answersIndex++;
      averageValues = (averageValues + parseInt(answer.split(',')));
    } else if( Array.isArray(answer) ) {
      answersSliders[answersSliderIndex] = answer[0];
      answersSliderIndex++;
      averageValues = (averageValues + parseInt(answer[0]));
    }
  }

  averageValues = Math.round( averageValues / getAnswers().length );

  const questionsSingle = [];
  let questionIndex = 0;

  for ( let i = 0; i < questions.length; i++ ) {
    const question = questions[i];

    if( question['type'] !== 'checkboxMulti' && question['type'] !== 'radioMulti' ) {
      questionsSingle[questionIndex] = question['heading'];
      questionIndex++;
    }
  }

  // Merge array for single answers with array for multiple answers
  const allAnswers = answers.concat(answersSliders);
  // Merge questions
  const allQuestions = questionsSingle.concat(questionsSliders);

  if(!configurations) return <Redirect to='/'/>;
  if(next) return <Redirect to='/register'/>;

  return (
    <SummaryContainer>
        <div clasName={'flex'}>
          <div className={"col-span-12"}>
            <a href={'/'}>
              <svg width="159.836" height="23.5" viewBox="0 0 159.836 23.5">
                <defs>
                  <clipPath id="clipPath">
                    <rect id="Rectangle_1540" data-name="Rectangle 1540" width="159.836" height="23.5" fill="none"/>
                  </clipPath>
                </defs>
                <g id="Group_3205" data-name="Group 3205" clipPath="url(#clipPath)">
                  <path id="Path_3798" data-name="Path 3798" d="M0,23.765V1.308H4.276V9.591A6.168,6.168,0,0,1,9.293,7.1c4.141,0,7.2,3.232,7.2,8.518,0,5.454-3.1,8.552-7.2,8.552a6.313,6.313,0,0,1-5.017-2.491v2.087Zm7.98-3.4c2.457,0,4.107-1.919,4.107-4.747,0-2.795-1.65-4.714-4.107-4.714a4.783,4.783,0,0,0-3.7,1.886v5.757a4.826,4.826,0,0,0,3.7,1.818" transform="translate(0 -0.669)" fill="#252424"/>
                  <path id="Path_3799" data-name="Path 3799" d="M38.292,29.818V13.557h4.276v2.188a7.131,7.131,0,0,1,5.185-2.592v4.175a5.52,5.52,0,0,0-5.185,1.751v10.74Z" transform="translate(-19.571 -6.723)" fill="#252424"/>
                  <path id="Path_3800" data-name="Path 3800" d="M69.727,29.818V28.1a6.635,6.635,0,0,1-5.151,2.12,5.39,5.39,0,0,1-5.622-5.386c0-3.838,3.03-5.252,5.622-5.252a6.639,6.639,0,0,1,5.151,1.986V19.516c0-1.65-1.414-2.727-3.569-2.727a6.834,6.834,0,0,0-4.679,1.919l-1.683-3a10.5,10.5,0,0,1,7.1-2.559c3.737,0,7.137,1.481,7.137,6.161v10.5Zm0-3.905v-2.02a4.3,4.3,0,0,0-3.434-1.448c-1.683,0-3.064.909-3.064,2.458s1.38,2.424,3.064,2.424a4.275,4.275,0,0,0,3.434-1.414" transform="translate(-30.13 -6.723)" fill="#252424"/>
                  <path id="Path_3801" data-name="Path 3801" d="M94.145,2.525a2.542,2.542,0,0,1,5.084,0,2.542,2.542,0,1,1-5.084,0m.4,4.309h4.276V23.1H94.549Z" transform="translate(-48.117 0)" fill="#252424"/>
                  <path id="Path_3802" data-name="Path 3802" d="M121.305,29.818V19.987c0-2.256-1.178-3.03-3-3.03a4.755,4.755,0,0,0-3.7,1.886V29.818h-4.276V13.557h4.276v2.088a7.605,7.605,0,0,1,5.69-2.491c3.6,0,5.319,2.02,5.319,5.185V29.818Z" transform="translate(-56.388 -6.723)" fill="#252424"/>
                  <path id="Path_3803" data-name="Path 3803" d="M147.32,23.413V10.889h-2.693V7.151h2.693V6.478c0-3.67,2.189-5.858,5.454-5.858a5.661,5.661,0,0,1,4.242,1.549L155.4,4.761a2.5,2.5,0,0,0-1.784-.639c-1.213,0-2.02.774-2.02,2.357v.673h3.3v3.737h-3.3V23.413Z" transform="translate(-73.917 -0.317)" fill="#252424"/>
                  <path id="Path_3804" data-name="Path 3804" d="M166.459,21.671a8.6,8.6,0,0,1,17.2,0,8.6,8.6,0,0,1-17.2,0m12.76,0c0-2.525-1.481-4.714-4.175-4.714-2.66,0-4.141,2.189-4.141,4.714,0,2.558,1.481,4.747,4.141,4.747,2.693,0,4.175-2.189,4.175-4.747" transform="translate(-85.075 -6.723)" fill="#252424"/>
                  <path id="Path_3805" data-name="Path 3805" d="M206.127,29.818V13.557H210.4v2.188a7.131,7.131,0,0,1,5.185-2.592v4.175a5.52,5.52,0,0,0-5.185,1.751v10.74Z" transform="translate(-105.349 -6.723)" fill="#252424"/>
                  <path id="Path_3806" data-name="Path 3806" d="M226.718,21.671a8.3,8.3,0,0,1,8.417-8.518c4.882,0,8.148,3.636,8.148,8.922v1.01H231.2c.3,1.986,1.919,3.637,4.68,3.637a6.8,6.8,0,0,0,4.309-1.583l1.919,2.828a10.139,10.139,0,0,1-6.7,2.255c-4.949,0-8.687-3.333-8.687-8.552m8.417-5.017a3.75,3.75,0,0,0-3.972,3.468h8.013a3.727,3.727,0,0,0-4.04-3.468" transform="translate(-115.873 -6.723)" fill="#252424"/>
                  <path id="Path_3807" data-name="Path 3807" d="M261.98,27.7l1.852-3.1a9.215,9.215,0,0,0,5.622,2.256c1.852,0,2.727-.707,2.727-1.717,0-2.66-9.629-.471-9.629-6.868,0-2.727,2.357-5.117,6.666-5.117a10.36,10.36,0,0,1,6.531,2.222l-1.718,3.03a7.011,7.011,0,0,0-4.814-1.885c-1.549,0-2.559.674-2.559,1.583,0,2.39,9.662.37,9.662,6.936,0,3-2.558,5.184-7.07,5.184A10.948,10.948,0,0,1,261.98,27.7" transform="translate(-133.895 -6.723)" fill="#252424"/>
                  <path id="Path_3808" data-name="Path 3808" d="M294.632,21.521V13.07h-2.693V9.333h2.693V4.889h4.276V9.333h3.3V13.07h-3.3v7.306c0,1.044.539,1.818,1.481,1.818a2.153,2.153,0,0,0,1.482-.505l.909,3.265A5.279,5.279,0,0,1,299.211,26c-3,0-4.579-1.549-4.579-4.477" transform="translate(-149.207 -2.499)" fill="#252424"/>
                  <path id="Path_3809" data-name="Path 3809" d="M315.767,39.569a2.727,2.727,0,1,1,2.727,2.727,2.759,2.759,0,0,1-2.727-2.727" transform="translate(-161.385 -18.83)" fill="#252424"/>
                </g>
              </svg>
            </a>
          </div>
        </div>
        
        <div className={'relative mb-10 mt-10'}>
          <div id={'banner'}  style={bannerStyle.shadow} className={bannerClasses}></div>
          <img src={image_url} onLoad={() => setImage({...image, loaded: true}) } className={'rounded-xl'} alt={'Banner'} />
        </div>

        <span className={'flex mb-4 mb-4 justify-start items-start'}>
          <span className={'text-size-12 leading-line-height-12 text-purple'}>{ ' ' + (questionIndex+1) } </span>
          <span className={'text-pinkish text-size-14 mx-2'}>|</span>
          <span className={'text-size-12 leading-line-height-12 text-gray'}>{ ' ' + (questionIndex+1) + ' ' }</span>
          <span className={"ml-4 text-size-14 leading-line-height-16 text-purple"}>{ 'Resultat' }</span>
        </span>

        <h1 className="text-3xl sm:text-5xl font-bold mb-6 text-size-28 leading-line-height-28 mb-6 text-purple font-700">{averageValues} poäng</h1>

        <p className={"text-size-15 line-height-12 sm:text-xl mb-10"}>{text}</p>

        <ul>
          {allAnswers.map( (a, i) => {
            return (
            <li key={uuidv4()} className="mb-2"> 
              <span className="text-base text-size-15 line-height-12">
                { allQuestions[i] + ' ' }
              </span> 
              -
              <span className="text-base text-size-15 line-height-12 font-500">
              { ' ' + a }
              </span>
            </li>)
          })}
        </ul>

        <div className={'mt-20 text-center'}>
          <input
            type="button"
            value="Kontakta oss"
            onClick={ handleSubmit }
            className="px-12 block w-full sm:w-auto sm:inline-block py-3 bg-blue text-white font-700 cursor-pointer rounded-lg" />
        </div>
    </SummaryContainer>

  );
};

export default SummaryView;
